const vxg01r = require('./public/bi.js');
const vkjii7v = require('./public/sites.js');
const vy9g8kl = require('./public/user-menu-code-backup.js');
const vjdncx = require('./public/wix-search.js');

module.exports = {
	...vxg01r,
	...vkjii7v,
	...vy9g8kl,
	...vjdncx
};
